import { CAlert, CButton, CButtonGroup, CLabel, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react';
import * as React from 'react';
import { ILogReader, ITechInfosClient } from '../abstraction';
import { AppLabels } from '../core/AppLabels';
import { ILogLineModel, KLogLine } from './';

interface IProps {
	isOpen: boolean;
	onClose: () => void;
	infos: ITechInfosClient;
	logsProvider: ILogReader;
}

interface IState {
	logFiles: string[];
	loading: boolean;
	logContent: ILogLineModel[];
	showLogContent: boolean;

	showDebug: boolean;
	showError: boolean;
	showWarning: boolean;
	showInfo: boolean;
	showCritical: boolean;

	showWeb: boolean;
	showKarma: boolean;
	showAPIS: boolean;
	showX3: boolean;
}

// Affiche un message d'erreur sur une Popup
// 
export class KTechPopup extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			logFiles: [],
			loading: true,
			logContent: [],
			showLogContent: false,

			showDebug: false,
			showError: true,
			showWarning: false,
			showInfo: false,
			showCritical: true,

			showWeb: true,
			showKarma: true,
			showAPIS: true,
			showX3: true,
		};

	}
	//#region React hacks

	UNSAFE_componentWillUpdate = (nextProps: IProps) => {
		if (nextProps.isOpen && !this.props.isOpen) {
			this.props.logsProvider.getLogList()
				.then(data => {
					this.setState({ logFiles: data });
				});
		}
	}

	//#endregion

	//#region Local events 

	// clic sur bouton fermeture
	close = () => {
		if (this.props.isOpen) this.props.onClose();
		this.setState({
			loading: false, showLogContent: false
		});
	}

	onOpenLogClick = async (file: string) => {
		this.setState({ loading: true });
		this.setState({ showLogContent: true });

		let lines: string[] = await this.props.logsProvider.getLogFile(file);

		let logContent: ILogLineModel[] = [];

		let i = 0;
		while (i < lines.length) {
			let l = lines[i].split(" - ");
			if (l.length>=2 ) {
				let index = lines[i].indexOf(l[2]);
				let message = lines[i].substring(index + 3 + l[2].length);

				logContent.push(
					{
						key: l[0],
						service: l[1],
						level: l[2],
						message: message
					}
				);
			}
			i++;
		}
		this.setState({ loading: false, logContent: logContent });
	}

	//#endregion

	//#region Rendus

	renderLogs = () => {
		

		return (
			<CModal scrollable={true} centered closeOnBackdrop={false} className={"KContentFullscreen "} show={this.props.isOpen} onClose={() => this.close()} >
				<CModalHeader>
					<CButtonGroup>
						<CButton color={!this.state.showCritical ? "light" : "primary"} onClick={() => this.setState({ showCritical: !this.state.showCritical })} active={!this.state.showCritical}>Critical</CButton>
						<CButton color={!this.state.showError ? "light" : "danger"} onClick={() => this.setState({ showError: !this.state.showError })} active={!this.state.showError}>Error</CButton>
						<CButton color={!this.state.showWarning ? "light" : "warning"} onClick={() => this.setState({ showWarning: !this.state.showWarning })} active={!this.state.showWarning}>Warning</CButton>
						<CButton color={!this.state.showInfo ? "light" : "info"} onClick={() => this.setState({ showInfo: !this.state.showInfo })} active={!this.state.showInfo}>Information</CButton>
						<CButton color={!this.state.showDebug ? "light" : "secondary"} onClick={() => this.setState({ showDebug: !this.state.showDebug })} active={!this.state.showDebug}>Debug</CButton>
					</CButtonGroup>

					<CButtonGroup>
						<CButton color={!this.state.showWeb ? "light" : "success"} onClick={() => this.setState({ showWeb: !this.state.showWeb })} active={!this.state.showWeb}>Serveur Web</CButton>
						<CButton color={!this.state.showAPIS ? "light" : "success"} onClick={() => this.setState({ showAPIS: !this.state.showAPIS })} active={!this.state.showAPIS}>Serveur APIS</CButton>
						<CButton color={!this.state.showKarma ? "light" : "success"} onClick={() => this.setState({ showKarma: !this.state.showKarma })} active={!this.state.showKarma}>Moteur Applicatif</CButton>
						<CButton color={!this.state.showX3 ? "light" : "success"} onClick={() => this.setState({ showX3: !this.state.showX3 })} active={!this.state.showX3}>X3</CButton>
					</CButtonGroup>
				</CModalHeader>
				<CModalBody >
					<table>
						<thead>
							<tr>
								<th>Time</th>
								<th>Service</th>
								<th>Level</th>
								<th>Message</th>
							</tr>
						</thead>
						<tbody>
							{
								this.state.logContent.map((l, i) => {
									if (
										(
											(this.state.showDebug && l.level == "Debug") ||
											(this.state.showInfo && l.level == "Information") ||
											(this.state.showWarning && l.level == "Warning") ||
											(this.state.showError && l.level == "Error") ||
											(this.state.showCritical && l.level == "Critical")
										)
										&&
										(
											(this.state.showWeb && l.service == "Karma.WebServer") ||
											(this.state.showKarma && l.service == "KarmaService") ||
											(this.state.showAPIS && l.service == "APIS") ||
											(this.state.showX3 && l.service == "X3Provider")
										)
									)
										return <KLogLine key={i} line={l} />
									else
										return null;
								})
							}
						</tbody>
					</table>
				</CModalBody>
				<CModalFooter>
					<CButton onClick={this.close} >{AppLabels.close}</CButton>{' '}
				</CModalFooter>
			</CModal>
		);
	}

	render() {
		let infos = this.props.infos.techInfosModel;
		let x = window.innerWidth.toString();
		let y = window.innerHeight.toString();
		let splt = infos.idTransaction.split('/');

		if (this.state.showLogContent) {
			return this.renderLogs();
		}

		return (
			<CModal centered closeOnBackdrop={false} className={"KAlertPopup "} show={this.props.isOpen} onClose={() => this.close()} >
				<CModalBody>
					<CAlert >
						<b>Technical informations : </b><br />
						<CLabel >Username : </CLabel><b> {infos.userName}</b><br />
						<CLabel >Language : </CLabel><b> {infos.lang}</b><br />
						<CLabel >Flow : </CLabel><b> {infos.flux}</b><br />
						<CLabel >Context : </CLabel><b> {infos.context}</b><br />
						<CLabel >Step : </CLabel><b> {infos.step}</b><br />
						<CLabel >Barcod : </CLabel><b> {infos.barCode}</b><br />
						<CLabel >Site : </CLabel><b> {infos.idSite}</b><br />
						<CLabel >Session : </CLabel><b> {splt[0]}</b><br />
						<CLabel >Transaction : </CLabel><b> {splt[1]}</b><br />
						<CLabel >Resolution : </CLabel><b> {x + " x " + y}</b><br />
						<hr />
						{this.state.logFiles.map((file, i) => {
							return (
								<CButton key={i} onClick={() => this.onOpenLogClick(file)} color="info" size="sm" block>{file}</CButton>
							)
						})}
					</CAlert>
				</CModalBody>
				<CModalFooter>
					<CButton onClick={this.close} >{AppLabels.close}</CButton>{' '}
				</CModalFooter>
			</CModal>
		);
	}
	//#endregion
}
